import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Groups from "./components/Groups";
import MenuItemsList from "./components/MenuItemsList";
import Cart from "../components/Cart";
import SearchNew from "../../layouts/components/SearchNew";
import { DeliveryType } from "../../constants/deliveryTypes";
import { orderTotal } from "../../redux/selectors/order";
import { isMobileAndTablet, isMobileApp } from "../../helpers/common";
import OpenCartBlock from "../components/OpenCartBlock";
import IPosModal from "../../IPosModal";
import { setBranchMessageShown } from "../../redux/actions/baseActions";
import { setMenuPresentation } from "../../redux/actions/menuActions";
import { MenuPresentationTypes } from "../../constants/menuPresentationTypes";

const getDimensions = (ele) => {
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    height,
    offsetTop,
    offsetBottom,
  };
};

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

const sectionRefs = [];

const OrderPage = ({
  currentDeliveryType,
  currentLanguageId,
  orderItems,
  totalAmount,
  selectedItem,
  currentTableId,
  branchInfo,
  setBranchMessageShown,
  branchMessageShown,
  menuPresentation,
  setMenuPresentation,
  t,
}) => {
  // const [currentView, setCurrentView] = useState('shop-list');
  const [visibleSection, _setVisibleSection] = useState(null);
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);

  const viasibleSectionRef = React.useRef(visibleSection);
  const forceUpdate = useForceUpdate();
  const history = useHistory();

  // const [sectionRefs, setSectionRefs] = useState([]);
  const isMobile = isMobileAndTablet();
  const cartTotalQuantity = orderItems.reduce((acc, item) => {
    return acc + item.orderItem.quantity;
  }, 0);

  const setVisibleSection = (data) => {
    viasibleSectionRef.current = data;
    _setVisibleSection(data);
  };

  const addToSectionsRefs = (obj) => {
    // setSectionRefs(sectionRefs.push(obj));
    sectionRefs.push(obj);
  };

  useEffect(() => {
    const el = document.getElementById("scrollable-items-container");
    el.addEventListener("scroll-y", () => {
      if (el.scrollTop > 300) {
        setShowScrollTopButton(true);
      } else {
        setShowScrollTopButton(false);
      }
    });

    if (branchInfo.use_pin_pad_flg === 1 || branchInfo.use_two_column) {
      setMenuPresentation(MenuPresentationTypes.Thumb);
    }
  }, []);

  useEffect(() => {
    if (
      !branchInfo.branch_guid_code ||
      !(currentTableId && currentDeliveryType === DeliveryType.EAT_IN)
    ) {
      return;
    }

    if (
      [DeliveryType.DELIVERY, DeliveryType.TA, DeliveryType.EAT_IN].includes(
        currentDeliveryType
      ) &&
      !branchInfo.IsWorkingDelivery
    ) {
      IPosModal.alert({
        title: "",
        message: t("dialogs.not_accepting_orders"),
        okButtonText: t("buttons.ok"),
        onOk: () => {
          history.push(`/${branchInfo.branch_guid_code}/type`);
        },
      });

      return;
    }

    // Show messages before show page (for case when delivery type = Eat In and table ID is present)
    if (!branchMessageShown) {
      const messagesToShow = branchInfo.MessagesInfo.filter(
        (msg) => msg.item_relations.length === 0
      );

      for (let i = 0; i < messagesToShow.length; i++) {
        if (messagesToShow[i].web_image_name_txt) {
          IPosModal.adImageModal({
            imagePath: messagesToShow[i].web_image_name_txt,
            onOk: () => {
              setBranchMessageShown(true);
            },
          });
        } else {
          IPosModal.alert({
            title: "",
            message: messagesToShow[i].message_txt,
            okButtonText: t("buttons.ok"),
            onOk: () => {
              setBranchMessageShown(true);
            },
          });
        }
      }
    }
  }, [branchInfo, branchMessageShown]);

  const scrollToTop = () => {
    const el = document.getElementById("scrollable-items-container");
    el.scrollTo({
      top: 0,
      behavior: "smooth", // for smoothly scrolling
    });
  };

  useEffect(() => {
    const visibleSectionName = visibleSection ? visibleSection.section : null;
    if (visibleSectionName) {
      const elem = document.getElementsByName(`${visibleSectionName}-menu`)[0];
      if (elem) {
        elem.scrollIntoView({ inline: "nearest", block: "nearest" });
      }
    }
  }, [visibleSection]);

  // useEffect(() => {
  //   // sectionRefs.splice(0, sectionRefs.length);
  // }, [currentLanguageId]);

  useEffect(() => {
    const container = document.getElementById("scrollable-items-container");
    const handleScroll = () => {
      // const { height: headerHeight } = getDimensions(headerRef.current);
      //const isMobile = isMobileAndTablet();
      //const mobileAppOffset = isMobileApp() ? 50 : 0;
      //const pageImageHeaderHeight = isMobile ? mobileAppOffset : 100;
      const scrollPosition = container.scrollTop;
      console.log(`Scroll position: `, scrollPosition);
      console.log(`sectionRefs: `, sectionRefs.length);

      const selected = sectionRefs.find(({ section, ref }) => {
        const ele = ref.current;
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele);
          // console.log("elem: ", ele);
          // console.log("elem offsetTop: ", ele.offsetTop);
          // console.log("elem offsetTop calc: ", offsetTop);
          // console.log(
          //   "scrollPosition > offsetTop - 60 && scrollPosition < offsetBottom",
          //   ele
          // );
          // console.log(
          //   `${scrollPosition} > ${offsetTop - 80} && ${scrollPosition} < ${
          //     offsetBottom - 80
          //   } `
          // );
          return (
            scrollPosition >= offsetTop - 80 &&
            scrollPosition < offsetBottom - 80
          );
        }
      });

      const visibleSectionName = viasibleSectionRef.current
        ? viasibleSectionRef.current.section
        : null;

      if (selected && selected.section !== visibleSectionName) {
        //console.log("Set section", selected);
        setVisibleSection(selected);
      } else if (!selected && visibleSectionName) {
        //console.log("Set section undefined");
        setVisibleSection(undefined);
      }
    };

    handleScroll();

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (selectedItem) {
      const itemElement = document.getElementById(
        `menu-item-${selectedItem.menu_item_id}`
      );
      const container = document.getElementById("scrollable-items-container");

      if (itemElement) {
        setTimeout(() => {
          container.scrollTo({
            top: itemElement.offsetTop,
          });
        }, 500);
      }
    }
  }, []);

  return (
    <div className={`shop ${menuPresentation}`} id="shop">
      <div className="container">
        <div className="col-md-3 groups-container sticky">
          <Groups visibleSection={visibleSection} />

          {showScrollTopButton && !isMobile && (
            <button onClick={scrollToTop} className="back-to-top">
              <FontAwesomeIcon icon="chevron-up" />
            </button>
          )}
        </div>

        <div
          className={`${
            currentDeliveryType === DeliveryType.MENU ? "col-md-9" : "col-md-5"
          } search-items-container`}
        >
          <div className="search_container">
            <SearchNew visibleSection={visibleSection} />
          </div>
          <div className="items-container" id="scrollable-items-container">
            {/*<div className={ `${currentDeliveryType === DeliveryType.MENU ? 'col-md-9' : 'col-md-5'} products-items-list` }>*/}
            <MenuItemsList addToSectionsRefs={addToSectionsRefs} />
          </div>
        </div>

        {currentDeliveryType !== DeliveryType.MENU && (
          <div className="col-md-4 sticky hidden-sm hidden-xs">
            <Cart />
          </div>
        )}

        {isMobile && orderItems.length > 0 && (
          <OpenCartBlock
            totalAmount={totalAmount}
            totalQuantity={cartTotalQuantity}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    currentDeliveryType,
    currentLanguageId,
    orderItems,
    selectedItem,
    currentTableId,
    branchInfo,
    branchMessageShown,
    menuPresentation,
  } = state;

  return {
    currentDeliveryType,
    currentLanguageId,
    totalAmount: orderTotal(state),
    orderItems,
    selectedItem,
    currentTableId,
    branchInfo,
    branchMessageShown,
    menuPresentation,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setBranchMessageShown,
      setMenuPresentation,
    },
    dispatch
  );
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(OrderPage)
);
